import '@vfde-brix/media-segment/dist/styles.css';
import '@vfde-brix/segment/dist/styles.css';
import '@vfde-brix/button/dist/styles.css';
import '@vfde-brix/image/dist/styles.css';
import '@vfde-brix/video/dist/styles.css';
import '@vfde-brix/youtube-video/dist/styles.css';
import { createMediaSegmentBlock } from '@vfde-brix/media-segment';
import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/core';
import { createComponents } from '../../utils/initComponents';

createComponents('brix-media-segment', createMediaSegmentBlock, NO_PATTERN_BUSINESS_LOGIC, element => element);
